import { SpinnerIndicators } from '@clearkit/icons';
import classnames from 'classnames';
import { CKContainerProps } from 'clearkit';
import { FC, ReactNode } from 'react';

type LoadingAreaProps = CKContainerProps & {
  emptyBody?: ReactNode;
  empty?: boolean;
  loading?: boolean;
};

const LoadingArea: FC<LoadingAreaProps> = ({
  className,
  children,
  empty,
  emptyBody = 'Nothing to show',
  loading,
  ...rest
}) => {
  const containerClasses = 'flex flex-col flex-auto min-h-0 min-w-0';

  const Loading = () => {
    return (
      <div className={`${containerClasses} items-center justify-center h-48`}>
        <SpinnerIndicators className="w-12 h-12" />
      </div>
    );
  };

  const Empty = () => {
    return (
      <div
        className={`${containerClasses} h-24 text-base items-center justify-center bg-gray-0 text-gray-400`}
      >
        {emptyBody}
      </div>
    );
  };

  const RenderInner = () => {
    if (loading) {
      return <Loading />;
    } else if (empty) {
      return <Empty />;
    } else {
      return <div className={containerClasses}>{children}</div>;
    }
  };

  return (
    <div {...rest} className={classnames(containerClasses, className)}>
      <RenderInner />
    </div>
  );
};

export default LoadingArea;
